import { useFormikContext } from 'formik';
import debounce from 'lodash/debounce';
import { useCallback, useEffect, useState } from 'react';

enum AutoSaveState {
	Submitting,
	Saved,
}

interface IAutoSaveProps {
	debounceMs: number;
	onAutoSaveStateChange?: (saveState: AutoSaveState) => void;
}

export const AutoSave = ({ debounceMs, onAutoSaveStateChange = () => {} }: IAutoSaveProps) => {
	const [initialized, setInitialized] = useState<boolean>(false);
	const formik = useFormikContext();
	const debouncedSubmit = useCallback(
		debounce(() => {
			return formik.submitForm();
		}, debounceMs),
		[formik.submitForm, debounceMs],
	);

	useEffect(() => {
		if (initialized) {
			debouncedSubmit();
		} else {
			setInitialized(true);
		}
	}, [debouncedSubmit, formik.values]);

	useEffect(() => {
		onAutoSaveStateChange(formik.isSubmitting ? AutoSaveState.Submitting : AutoSaveState.Saved);
	}, [formik.isSubmitting]);

	return null;
};
